export let ClinicComponentState = /*#__PURE__*/function (ClinicComponentState) {
  ClinicComponentState["Good"] = "GOOD";
  ClinicComponentState["Bad"] = "BAD";
  ClinicComponentState["Disabled"] = "DISABLED";
  return ClinicComponentState;
}({});